import Logo from '../image/Mersin-Inc-Logo.jpg';

const Navbar = () => {
  return (
    <nav className='text-primery-300 bg-white px-4'>
      <div className='flex justify-around space-x-1  '>
        <div>
          <div className=' px-2'>
            <img src={Logo} className='w-50' alt='taqnya logo' />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
